import React from 'react';

const HeroGradientBlobs: React.FC = () => (
  <div
    aria-hidden="true"
    className="pointer-events-none absolute inset-0 overflow-hidden"
  >
    <div className="bg-theme-primary-light absolute bottom-[-5%] left-[3%] aspect-square w-[70%] rounded-full opacity-70 blur-[138px] sm:bottom-[-30%] sm:w-[32%]" />
    <div className="bg-lavender-300 absolute bottom-0 left-[23%] aspect-square w-[70%] rounded-full opacity-55 blur-[138px] sm:bottom-[-20%] sm:w-[36%]" />
    <div className="bg-theme-primary absolute bottom-[-5%] left-[40%] aspect-square w-[60%] rounded-full opacity-35 blur-[138px] sm:bottom-[-30%] sm:w-[36%]" />
    <div className="bg-info-300 absolute right-[5%] bottom-[-5%] aspect-square w-[70%] rounded-full opacity-65 blur-[138px] sm:bottom-[-30%] sm:w-[40%]" />
  </div>
);

export default HeroGradientBlobs;
